module.exports = __webpack_public_path__ + "22_big.jpg?42ead847b08e05ffe0b309deb9675fd7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/22_big.jpg
// module id = 182
// module chunks = 0